import {
  FETCH_SEARCH_RESULT,
} from '../mutation-types'

const initialState = {
  matches: [],
  routes: [],
  customRoutes: [],
  totalMatches: 0,
  totalRoutes: 0,
  totalCustomRoutes: 0,
}

const mutations = {
  [FETCH_SEARCH_RESULT](state, data) {
    state.matches = data.matches
    state.routes = data.routes
    state.customRoutes = data.customRoutes
    state.totalMatches = data.totalMatches
    state.totalRoutes = data.totalRoutes
    state.totalCustomRoutes = data.totalCustomRoutes
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/search.js